export default __webpack_public_path__ + "static/33_31-ab9bc951f4d25655bdcbaeb224f28438.png";